import BaseService from './base/base.service'

export default class OrderService extends BaseService {

    constructor(){
        super('order')
    }
}